var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.9,
    d: "M20.48 4.764c.143.103.227.272.227.454v17.616c0 .182-.084.352-.226.454-.09.064-.191.097-.296.097-.064 0-.126-.012-.188-.036l-13.484-5.47H2.785c-1.214 0-2.202-.987-2.202-2.201v-3.303c0-1.215.988-2.202 2.202-2.202H6.51l13.488-5.47c.162-.065.34-.041.484.061zm-.817 1.256L7.189 11.078v5.895l12.474 5.06V6.02zm4.205 11.952l3.303 2.202c.252.169.322.511.153.763-.107.16-.28.246-.458.246-.106 0-.211-.03-.305-.093l-3.303-2.202c-.252-.168-.321-.51-.153-.763.17-.253.513-.32.763-.153zm-17.78-6.698H2.785c-.607 0-1.1.493-1.1 1.1v3.304c0 .608.493 1.1 1.1 1.1h3.303v-5.504zm20.778 2.752c.304 0 .55.247.55.55 0 .305-.246.551-.55.551h-3.303c-.304 0-.55-.246-.55-.55 0-.304.246-.55.55-.55h3.303zm.458-5.81c.169.252.1.595-.153.763l-3.303 2.202c-.094.063-.2.093-.305.093-.177 0-.351-.086-.458-.246-.168-.252-.1-.594.153-.763l3.303-2.202c.251-.167.594-.101.763.153z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountMarketing);
export default __webpack_public_path__ + "static/media/account_marketing.459db5fa30c0dd1ddf81bd920330c46f.svg";
export { ForwardRef as ReactComponent };